module.exports = "<div class=\"icon--delivery feature-promo--icon\"></div>\r\n<div class=\"skewed\"><div class=\"feature-promo--text feature-promo--text-title\"><a href=\"/help/delivery\">Delivery</a> now available!</div></div>\r\n<div class=\"feature-promo--text feature-promo--text-subtitle\">\r\n\tSet delivery to <a class=\"link-underline\" ng-click=\"setDelivery()\">{{storePickerPanelService.deliverySearch.SuburbName}}</a>?\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/feature-promo/features/feature-delivery/feature-delivery-template.html
 ** module id = 933
 ** module chunks = 1
 **/